import { formatEquipmentUseYn, isEquipmentInUse } from '../../types/manufacturingEquipment';

interface Props {
  useYn?: string | null;
  className?: string;
}

function EquipUseStatus({ useYn, className = '' }: Props) {
  const inUse = isEquipmentInUse(useYn);
  return (
    <span className={`equip-use-status${inUse ? ' is-on' : ' is-off'}${className ? ` ${className}` : ''}`}>
      <i aria-hidden="true" />
      {formatEquipmentUseYn(useYn)}
    </span>
  );
}

export default EquipUseStatus;
